import classNames from "classnames";
import styles from "./style.module.scss";
import { Images } from "assets";

const ImageSection = () => {
  return (
    <section className="relative pb-12 flex flex-col items-center">
      <div className={classNames(styles.leftYellowContainer)} />
      <div className={classNames(styles.rightYellowContainer)} />
      <div className={classNames(styles.bottomYelloContainer)} />
      <div className={styles.absContainer} />
      <div
        className={classNames(styles.customContainer, styles.responsivePadding)}
      >
        <div className={classNames(styles.imageOuterCont)}>
          <img src={Images.MainImage} alt="" />
        </div>
      </div>
    </section>
  );
};

export default ImageSection;
